<div class="col-sm-12">

    <h3>Informações da análise

        <div class="btn-group pull-right" id="btn-group-open-close" (click)="clickEventHandler()">
            <button type="button" class="btn btn-default">{{analiseRepasseStatus}}</button>
            <button type="button" class="btn btn-default dropdown-toggle" data-toggle="dropdown" aria-expanded="false">
                <span class="caret"></span>
                <span class="sr-only">Toggle Dropdown</span>
            </button>
            <ul class="dropdown-menu" role="menu">
                <li class="cursor"><a (click)="changeStatus(0)">Em análise</a></li>
                <li class="cursor"><a (click)="changeStatus(1)">Aprovado</a></li>
                <li class="cursor"><a (click)="changeStatus(2)">Aprovado com ressalvas</a></li>
                <li class="cursor"><a (click)="changeStatus(3)">Reprovado</a></li>
            </ul>
        </div>
    </h3>
    <hr>

    <div class="col-sm-12">

        <label>Documento comprobatório:</label><br>
        <button class="btn btn-primary btn-sm" (click)="openModalUpload('convenio')">Anexar arquivo</button>

        <br>
        <br>

        <table class="table" *ngIf="dataUploadArray.length">
            <thead>
                <tr>
                    <th width="50%">Nome arquivo</th>
                    <th>Tamanho</th>
                    <th class="text-center">Remover</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let item of dataUploadArray">
                    <td>
                        <strong>{{ item.originalname }}</strong>
                    </td>
                    <td nowrap>{{ item.size/1024/1024 | number:'.2' }} MB</td>
                    <td class="text-center">
                        <span>
                            <i class="glyphicon glyphicon-remove cursor"
                                (click)="removeFileProposta(item, 'convenio')"></i>
                        </span>
                    </td>
                </tr>
            </tbody>
        </table>


        <div class="col-sm-12 no-padding" style="margin-bottom: 30px;" *ngIf="analiseRepasse.anexo">
            <h4>Arquivo já inserido <br>
                <small style="color: #f97878;">Se inserir um novo arquivo esse será descartado.</small>
            </h4>
            <div class="box-shadow-elevation notificacao-anexo pull-left"
                (click)="openModalAnexo(analiseRepasse.hashAnexo)">
                <div class="col-sm-2 no-padding" style="display: flex; align-items: center; justify-content: center;">
                    <i class="far fa-file" style="font-size: 25px;"></i>
                </div>
                <div class="col-sm-10 no-padding" style="align-items: center; justify-content: center;">
                    <b class="mailbox-attachment-name">{{ analiseRepasse.anexo | slice:0:20 }}<span
                            *ngIf="analiseRepasse.anexo.length > 20">...{{analiseRepasse.anexo | slice:-4}}</span></b>
                </div>
            </div>
        </div>

        <br>

        <label>Análise:</label>
        <p-editor [(ngModel)]="observacao" *ngIf="observacaoView"></p-editor>

        <hr>
        <button class="btn btn-success" (click)="salvar()">Salvar</button>
        <br>
        <br>


    </div>

</div>

<p-dialog [(visible)]="openModalViewUpload" width="700" showEffect="fade" [modal]="true">
    <div class="col-sm-12">
        <h3>Upload de arquivos.</h3>
        <button type="button" class="btn btn-success  btn-sm" (click)="adicionarArquivo()">
            <i class="fa fa-fw fa-save"></i> Salvar
        </button>
        <hr>
    </div>
    <div class="col-sm-12">
        <app-upload-service></app-upload-service>
        <hr>
    </div>
</p-dialog>

<p-dialog [style]="{width: '800px'}" header="{{nomeAnexo}}" [(visible)]="displayAnexo" showEffect="fade" [modal]="true">
    <div class="col-sm-12">
        <h3>Anexo</h3>
        <hr>
    </div>
    <div class="col-sm-12 text-center">
        <div class="embed-container" *ngIf="viewDownload">
            <div class="myIframe">
                <iframe [src]="urlDocumento | safe" frameborder='0'></iframe>
            </div>
        </div>
    </div>
</p-dialog>